import React,{useEffect} from 'react';
import {useNavigate} from 'react-router';

const LogOut = ({setIsAuthenticated}) => {
    const navigate = useNavigate();
    useEffect(() => {
        setIsAuthenticated(false);
        localStorage.setItem("profile", null);
        navigate("/");
    }, []);
  return (
    <div></div>
  )
}

export default LogOut